<template>
  <div class="container-size" style="margin-top: 63px">
    <popup :message="alertErrMessage" v-if="isAlertErr" :isError="isError" @close="isAlertErr = false" />
    <div class="hero">
      <div class="content">
        <h1>{{ $t('talentService.heroSection.title') }}</h1>
        <p>{{ $t('talentService.heroSection.description') }}</p>
        <div class="btn-cta">
          <button class="now" @click="scrollToSection('collab')">
            {{ $t('talentService.heroSection.ctaButtons.collaborateNow') }}
          </button>
          <button class="call" @click="sendToWa">
            {{ $t('talentService.heroSection.ctaButtons.contactUs') }}
          </button>
        </div>
      </div>
      <div class="card-img">
        <img src="/img/corporate/talent-service/main.png" width="520" alt="" style="border-radius: 0 0 0 120px;" />
      </div>
    </div>
    <div class="container-fade">
      <div class="left-fade"></div>
      <div class="right-fade"></div>
    </div>
    <div class="creditbility">
      <div class="partner">
        <h1>{{ $t('talentService.trustedPartners.title') }}</h1>
        <div class="card" style="overflow-x: none !important;">
          <div v-for="(partner, index) in partners" :key="index">
            <div class="logo-card-partner-2">
              <img :src="partner.img_url_web" width="160" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="product-collaboration">
      <h1 style="margin: 0;">{{ $t('talentService.services.title') }}</h1>
      <p style="margin: 0; margin-bottom: 30px;">
        {{ $t('talentService.services.description') }}
      </p>
      <img src="/img/corporate/talent-service/line-cv.png" height="" alt=""
        style="width: 78%; display: block; margin: auto; margin-bottom: 20px;" />
      <div class="card-product">
        <div class="product" v-for="(product, idx) in products" :key="idx">
          <img :src="product.icon" width="60" height="60" alt="" />
          <h4>{{ $t(`talentService.products.${idx}.title`) }}</h4>
          <p>{{ $t(`talentService.products.${idx}.desc`) }}</p>
        </div>
      </div>
    </div>
    <div class="bg-linear">
      <div class="layanan-requirement">
        <h2 class="pt-5 mb-8 text-center">{{ $t(`talentService.a5`) }}</h2>
        <div class="layanan-requirement-card">
          <div class="card-list" v-for="(data, idx) in trainData" :key="idx">
            <div class="icon">
              <components :is="data.icon"></components>
            </div>
            <h2 class="text-center">{{ $t(`talentService.trainData.${idx}.name`) }}</h2>
            <p>{{ $t(`talentService.trainData.${idx}.desc`) }}</p>
            <h3 class="mt-5">{{ $t(`talentService.trainData.${idx}.quest`) }}</h3>
            <ul>
              <li v-for="(data2, idx2) in $t(`talentService.trainData.${idx}.list`)" :key="idx2">{{ data2 }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="usp">
      <div class="card-usp">
        <h1>{{ $t('talentService.whyChoose.title') }}</h1>
        <p v-html="$t('talentService.whyChoose.description')"></p>
        <div class="card-img">
          <img src="/img/corporate/talent-service/main2.png" alt="" />
        </div>
      </div>
      <div class="usp-container">
        <div class="card-usp" v-for="(data, idx) in usps" :key="idx">
          <div class="title-container">
            <components class="svg-comment" :is="data.icon" width="60" height="60"></components>
            <h3>{{ $t(`talentService.usp.${idx}.title`) }}</h3>
          </div>
          <div class="content">
            <p>{{ $t(`talentService.usp.${idx}.desc`) }}</p>
          </div>
          <hr />
        </div>
      </div>
    </div>
    <div class="bg-linear">
      <StepCollaboration :title="$t('talentService.a8')" :steps="$t('talentService.steps')" bgColor="white" />
      <div class="creditbility">
        <div class="partner">
          <h1 class="mb-4">{{ $t('talentService.a6') }}</h1>
          <div class="card" style="overflow-x: none !important;">
            <div v-for="(partner, index) in ocupation1" :key="index">
              <div class="logo-card-partner-2" style="width: max-content;">
                <div class="box-1">
                  <div><img :src="partner.img" alt=""></div>
                  <p>{{ partner.title }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="creditbility" style="padding-bottom: 120px; margin-top: -40px;">
        <div class="partner">
          <div class="card" style="overflow-x: none !important;">
            <div v-for="(partner, index) in ocupation2" :key="index">
              <div class="logo-card-partner-3" style="width: max-content;">
                <div class="box-1">
                  <div><img :src="partner.img" alt=""></div>
                  <p>{{ partner.title }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <v-row class="d-flex justify-center align-center mt-6">
        <v-btn elevation="0" class="btn-apply" @click="scrollToSection('collab')">{{ $t('talentService.a7') }}</v-btn>
      </v-row>
    </div>

    <div class="form-konsultasi mt-10" id="collab">
      <div class="header text-center">
        <h1 style="margin: 0;">{{ $t('talentService.formSection.title') }}</h1>
      </div>

      <div class="sub-heading mt-1 text-center">
        <p style="margin: 0;">{{ $t('talentService.formSection.subTitle') }}</p>
        <v-form class="text-start" style="margin-top: 60px">
          <v-row>
            <v-col cols="6">
              <label class="form-label" for="company">
                {{ $t('talentService.formSection.labels.companyName') }}
                <span style="color: rgba(184, 15, 10, 1)">*</span>
              </label>
              <v-text-field
                class="form-input text-form"
                name="company"
                v-model="form.corporate_name"
                outlined
                :placeholder="$t('talentService.formSection.placeholders.companyName')"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <label class="form-label" for="website">
                {{ $t('talentService.formSection.labels.website') }}
              </label>
              <v-text-field
                class="form-input text-form"
                name="website"
                v-model="form.web_url"
                outlined
                :placeholder="$t('talentService.formSection.placeholders.website')"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <label class="form-label" for="pic-name">
                {{ $t('talentService.formSection.labels.picName') }}
                <span style="color: rgba(184, 15, 10, 1)">*</span>
              </label>
              <v-text-field
                class="form-input text-form"
                name="pic-name"
                v-model="form.full_name"
                outlined
                :placeholder="$t('talentService.formSection.placeholders.picName')"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <label class="form-label" for="occupation">
                {{ $t('talentService.formSection.labels.occupation') }}
              </label>
              <v-text-field
                class="form-input text-form"
                name="occupation"
                v-model="form.job_pic"
                outlined
                :placeholder="$t('talentService.formSection.placeholders.occupation')"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <label class="form-label" for="email">
                {{ $t('talentService.formSection.labels.email') }}
                <span style="color: rgba(184, 15, 10, 1)">*</span>
              </label>
              <v-text-field
                class="form-input text-form"
                name="email"
                v-model="form.email"
                outlined
                :placeholder="$t('talentService.formSection.placeholders.email')"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <label class="form-label" for="phone-number">
                {{ $t('talentService.formSection.labels.phoneNumber') }}
                <span style="color: rgba(184, 15, 10, 1)">*</span>
              </label>
              <v-text-field
                class="form-input text-form"
                name="phone-number"
                outlined
                :placeholder="$t('talentService.formSection.placeholders.phoneNumber')"
                type="number"
                v-model="form.phone_number"
                hide-spin-buttons
              >
                <template v-slot:prepend-inner>
                  <v-row class="d-flex align-center mt-0 ml-7">
                    <img
                      src="/img/other/flag-indonesia.png"
                      alt=""
                      width="30"
                      height="20"
                      style="box-shadow: 2px 2px 3px 1px rgba(13, 28, 113, 0.1)"
                    />
                    <span style="color: #575966" class="mx-3">+62</span>
                  </v-row>
                </template>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="form-collab">
              <label class="form-label" for="collaboration">
                {{ $t('talentService.formSection.labels.collaborationType') }}
              </label>
              <v-text-field
                class="form-input text-form"
                solo
                flat
                background-color="rgba(247, 249, 253, 1)"
                :placeholder="$t('talentService.formSection.placeholders.collaborationType')"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="d-flex justify-center align-center mt-3">
            <v-checkbox class="form-input custom-checkbox" v-model="is_confirm">
              <template v-slot:label>
                <p class="label-checkbox" v-html="$t('talentService.formSection.labels.confirmCheckbox')"></p>
              </template>
            </v-checkbox>
          </v-row>

          <v-row class="d-flex justify-center align-center mt-6">
            <v-btn elevation="0" :class="`btn-kirim ${is_confirm ? 'confirm' : 'reject'}`" @click="onSubmit">
              {{ $t('talentService.formSection.buttons.submit') }}
            </v-btn>
          </v-row>
        </v-form>
      </div>
    </div>
    <div class="faq" style="margin-top: 40px;">
      <div class="content">
        <div class="row">
          <div class="col-lg-3">
            <div class="header">
              <h1>Frequently Asked Question</h1>
            </div>
          </div>
          <div class="col-lg-9" style="margin-top: 15px;">
            <v-expansion-panels flat class="faq-card" style="padding: 10px; background-color: #F1F6FF;">
              <v-expansion-panel v-for="(item, index) in questions" :key="index"
                style="border-radius: 20px; padding: 0; margin-bottom: 10px;">
                <v-expansion-panel-header disable-icon-rotate @click="openFaq(index, item.title)">
                  <h2 style="margin: 25px 0; font-size: 18px;">{{ item.title }}</h2>
                  <template v-slot:actions>
                    <div class="icon" v-if="item.active">
                      <Arrow />
                    </div>
                    <div v-else>
                      <Arrow :down="!item.active" />
                    </div>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div v-html="item.description"></div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <div style="margin-left: -10px;">
              <div class="btn-stoke-blue" @click="goToFaq">
                <span class="font-poppins">{{ $t('corpAceleration.faqSection.viewMore') }}</span>
                <ArrowLong />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Arrow from '@/assets/icons/Arrow.vue';
import StepCollaboration from '../../StepCollaboration.vue';
import Popup from "@/components/others/Popup.vue";
import PeopleTrain from '@/assets/icons/corporate/PeopleTrain.vue';
import CardTrain from '@/assets/icons/corporate/CardTrain.vue';
import M1Talent from '@/assets/icons/corporate/M1Talent.vue';
import M2Talent from '@/assets/icons/corporate/M2Talent.vue';
import M3Talent from '@/assets/icons/corporate/M3Talent.vue';
import M4Talent from '@/assets/icons/corporate/M4Talent.vue';
import M5Talent from '@/assets/icons/corporate/M5Talent.vue';
import M6Talent from '@/assets/icons/corporate/M6Talent.vue';
import ArrowLong from '@/assets/icons/ArrowLong.vue';

export default {
  components: {
    StepCollaboration,
    Popup,
    ArrowLong,
    Arrow,
    CardTrain,
    PeopleTrain,
    M1Talent,
    M2Talent,
    M3Talent,
    M4Talent,
    M5Talent,
    M6Talent,
  },
  name: "TalentAsServiceDesktop",
  data() {
    return {
      products: [
        {
          icon: "/img/corporate/talent-service/c1.png",
        },
        {
          icon: "/img/corporate/talent-service/c2.png",
        },
        {
          icon: "/img/corporate/talent-service/c3.png",
        },
        {
          icon: "/img/corporate/talent-service/c4.png",
        },
        {
          icon: "/img/corporate/talent-service/c5.png",
        },
      ],
      partners: [],
      usps: [
        {
          icon: M1Talent,
        },
        {
          icon: M2Talent,
        },
        {
          icon: M3Talent,
        },
        {
          icon: M4Talent,
        },
        {
          icon: M5Talent,
        },
        {
          icon: M6Talent,
        },
      ],
      ocupation1: [
        {
          img: "/img/corporate/talent-service/k1.png",
          title: "Cyber Security"
        },
        {
          img: "/img/corporate/talent-service/k2.png",
          title: "Database Administrator"
        },
        {
          img: "/img/corporate/talent-service/k2.png",
          title: "Data Engineer"
        },
        {
          img: "/img/corporate/talent-service/k3.png",
          title: "Data Analyst"
        },
        {
          img: "/img/corporate/talent-service/k4.png",
          title: "Mobile Developer"
        },
        {
          img: "/img/corporate/talent-service/k11.png",
          title: "Scrum Master"
        },
      ],
      ocupation2: [
        {
          img: "/img/corporate/talent-service/k5.png",
          title: "Product Manager"
        },
        {
          img: "/img/corporate/talent-service/k6.png",
          title: "Product Design"
        },
        {
          img: "/img/corporate/talent-service/k7.png",
          title: "Quality Assurance"
        },
        {
          img: "/img/corporate/talent-service/k8.png",
          title: "Risk Analyst"
        },
        {
          img: "/img/corporate/talent-service/k9.png",
          title: "System Administrator"
        },
        {
          img: "/img/corporate/talent-service/k12.png",
          title: "Web Developer"
        },
      ],
      trainData: [
        {
          icon: CardTrain,
          name: "IT Outsourcing",
          desc: "Kami menyediakan dan mengelola talenta digital dengan beragam level dan role position di bidang teknologi digital yang siap mendukung optimasi dan produktivitas bisnis perusahaan Anda",
          quest: "Mengapa pilih IT Outsourcing?",
          list: ['Perusahaan dapat fokus melakukan aktivitas bisnis utama', 'Perusahaan tidak perlu menyediakan fasilitas dan tunjangan', 'Perusahaan akan mendapatkan talenta digital yang berkualitas', 'Perusahaan tidak perlu repot melakukan proses rekrutmen', 'Menghemat Biaya Operasional Signifikan', 'Akses Talenta Digital dan Teknologi Baru']
        },
        {
          icon: PeopleTrain,
          name: "IT Head Hunting",
          desc: "Kami menyediakan layanan perekrutan dan menemukan talenta digital berkualitas serta profesional melalui mekanisme perekrutan yang kompatibel dan terstruktur untuk menjawab kebutuhan perusahaan Anda",
          quest: "Mengapa pilih Head Hunting?",
          list: ['Efisiensi biaya dan waktu', 'Identifikasi kandidat yang cocok dengan posisi yang tersedia', 'Menemukan talenta digital yang kompatibel', 'Mempercepat proses sourcing dan screening', 'Mendapatkan garansi pergantian talenta digital sesuai dengan kesepakatan']
        },
      ],
      questions: [],
      alertErrMessage: "",
      isAlertErr: false,
      is_confirm: false,
      isError: false,
      form: {
        full_name: "",
        email: "",
        phone_number: "",
        gender: "",
        corporate_name: "",
        company_field: "",
        program: "",
        total_student: 0,
        notes: "",
        category: "TALENT_SERVICE",
        web_url: "",
        job_pic: ""
      },
    };
  },
  watch: {
    "$i18n.locale"() {
      this.getFaq();
    },
  },
  methods: {
    sendToWa() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Contact Us - WhatsApp - Talent Service',
        value: 1,
      });
      window.open(
        "https://api.whatsapp.com/send/?phone=6282127274632&text=Hi%20Kak%20HiColleagues,%20saya%20mau%20bertanya",
        "_blank"
      );
    },
    scrollToSection(sectionId) {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: sectionId === 'collab' ? 'Collaborate Now - Scroll to Form - Talent Service' : 'Apply Now - Scroll to Form - Talent Service',
        value: 1,
      });
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
    duplicateOcupation1() {
      this.ocupation1 = this.ocupation1.concat(this.ocupation1, this.ocupation1, this.ocupation1);
    },
    duplicateOcupation2() {
      this.ocupation2 = this.ocupation2.concat(this.ocupation2, this.ocupation2, this.ocupation2);
    },
    duptlicatePartners() {
      this.partners = this.partners.concat(this.partners, this.partners, this.partners);
    },
    async getClientLogo() {
      try {
        const resp = await this.$http.get("/v1/logo?category=TALENT_SERVICE");
        this.partners = resp.data.data.logos;
        this.duptlicatePartners();
      } catch (err) {
        console.log(err);
      }
    },
    openFaq(idx, title) {
      this.$gtag.event('click', {
        event_category: 'FAQ',
        event_label: `Open FAQ - ${title} - Talent Service`,
        value: 1,
      });
      const valDef = this.questions[idx].active;
      this.questions.forEach(e => {
        e.active = false;
      });
      this.questions[idx].active = !valDef;
    },
    async getFaq() {
      this.questions = [];
      try {
        const resp = await this.$http.get(`/v1/faq?category=TALENT_SERVICE&is_main=true`);
        this.questions = resp.data.data.faq.map((item) => ({
          description: item.answer[0],
          title: item.question,
          active: false
        }));
      } catch (err) {
        console.log(err);
      }
    },
    async onSubmit() {
      this.$gtag.event('click', {
        event_category: 'Form',
        event_label: 'Submit Talent Service Form',
        value: 1,
      });
      if (!this.is_confirm) {
        return;
      }
      if (!this.form.corporate_name || !this.form.full_name || !this.form.job_pic || !this.form.email || !this.form.phone_number || !this.form.category || !this.form.web_url) {
        this.alertErrMessage = "Harap isi semua form yang tersedia";
        this.isAlertErr = true;
        this.isError = true;
        this.$gtag.event('form_submission', {
          event_category: 'Form',
          event_label: 'Talent Service Form Submission Error',
          value: 0,
        });
        return;
      }
      try {
        await this.$http.post('/v1/corporate-registration', this.form);
        this.alertErrMessage = "Success";
        this.isAlertErr = true;
        this.isError = false;
        this.clearForm();
        this.$gtag.event('form_submission', {
          event_category: 'Form',
          event_label: 'Talent Service Form Submission Success',
          value: 1,
        });
      } catch {
        this.alertErrMessage = "Error saat submit data";
        this.isAlertErr = true;
        this.isError = true;
        this.$gtag.event('form_submission', {
          event_category: 'Form',
          event_label: 'Talent Service Form Submission Error',
          value: 0,
        });
      }
    },
    goToFaq() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'View More FAQs - Talent Service',
        value: 1,
      });
      this.$router.push('/faq');
    },
    clearForm() {
      this.is_confirm = false;
      this.form.full_name = "";
      this.form.email = "";
      this.form.phone_number = "";
      this.form.corporate_name = "";
      this.form.category = "";
      this.form.web_url = "";
      this.form.job_pic = "";
    },
  },
  mounted() {
    this.getClientLogo();
    this.getFaq();
    this.duplicateOcupation1();
    this.duplicateOcupation2();
  }
};
</script>

<style src="./index.css" scoped></style>